import type { EntityConfig } from '../types'

export const securityPolicyEntity: EntityConfig = {
  id: 'security-policy',
  displayName: 'Security Policy',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'disabled', label: 'Disabled' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'disabled', label: 'Disabled', color: 'neutral' },
    ],
    mappings: {
      all: ['active', 'disabled'],
      active: ['active'],
      disabled: ['disabled'],
    },
  },
  queryFields: {},
  uiFilterFields: ['search', 'status', 'role'],
}
